/* global ajax */
import ScrollOut from 'scroll-out';

$(document).ready(function () {
  let scrollOut = ScrollOut({
    treshold: 0,
    once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  //ajax loadmore
  function loadMoreAjax() {
    $('body').on('click', '.blog-loadmore__button', function () {
      var button = $(this),
        queryArgs = button.data('args'),
        maxPage = button.data('max-page'),
        currentPage = button.attr('data-current-page');
      $.ajax({
        url: ajax.url,
        data: {
          action: 'custom_loadmore', // the parameter for admin-ajax.php
          query: queryArgs,
          page: currentPage,
        },
        type: 'POST',
        // eslint-disable-next-line no-unused-vars
        beforeSend: function (xhr) {
          button.text('Loading...');
        },
        success: function (data) {
          currentPage++;
          button
            .text('Load More')
            .attr('data-current-page', currentPage)
            .parent()
            .before(data);
          if (currentPage == maxPage) {
            button.remove();
          }
          scrollOut.index();
          scrollOut.update();
        },
      });
      return false;
    });
  }

  loadMoreAjax();
});
